import React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

const Wrapper = styled.div`
  & ::selection {
    background: none;
    color: none;
    }
`
const NavbarContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  height: 90px;
  width: 1049.22px;
  left: 50%;
  transform: translateX(-50%);

  position: relative;
  z-index: 2;
  transition: all 2000ms;
  background-color:#1e3250d9;
`
const Logo = styled.img`
  width: 180px;
  top: 50%;
  position: absolute;
  transform: translateY(-50%);
  left: 20px;
  cursor: pointer;
`
const Title = styled.p`
  font-family: 'Roboto';
  font-size: 15px;
  color: white;
  letter-spacing: 0.7px;
  position: absolute;
  margin: 0;
  top: 50%;
  transform: translateY(-50%);
  left: 260px;
`
const SubNavContainer = styled.div`
  background: #131e3c;
  height: 25px;
  width: 100%;
  position: relative;
  top: 0px;
`
const Nav = styled.nav`
  max-width: 1280px;
  position: relative;
  float: left;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  transition: all 400ms;
  > a {
    font-family: 'Roboto';
    font-size: 15px;
    font-weight: 700;
    color: white;
    transition: all 300ms;
    text-decoration: none;
    cursor: pointer;
    margin-right: 2px;
    background: #17263d99;
    padding:4px 100px;
  }
  > a:hover{
    background: #292948;
  }

  ${props => props.currentPage === "overview" && css`

    > a:nth-child(1){
      background: #6e96b5;
      color: #212846;
    }
  `}
  ${props => props.currentPage === "tenprinciples" && css`

  > a:nth-child(2){
    background: #6e96b5;
    color: #212846;
  }
  `}
  ${props => props.currentPage === "sdgs" && css`

  > a:nth-child(3){
    background: #6e96b5;
    color: #212846;
  }
  `}
  ${props => props.currentPage === "impact" && css`

    > a:nth-child(4){
      background: #6e96b5;
      color: #212846;
    }
  `}
`
export default class Navbar extends React.Component {

  constructor(props){
    super(props);
    this.checkURL = this.checkURL.bind(this);
  }

  componentWillMount() {
    this.checkURL();
  }
  componentWillUpdate(){
    this.checkURL();
  }

  checkURL(){
    const regex_impact = RegExp('impact','gi');
    const regex_tenprinciples = RegExp('tenprinciples','gi');
    const regex_sdgs = RegExp('sdgs','gi');
    const regex_overview_root = RegExp('/','gi');
    const regex_overview_url = RegExp('overview','gi');

    if(regex_impact.test(window.location.pathname)){
      this.currentPage = 'impact';
    }
    else if (regex_tenprinciples.test(window.location.pathname)) {
      this.currentPage = 'tenprinciples';
    }
    else if (regex_sdgs.test(window.location.pathname)) {
      this.currentPage = 'sdgs';
    }else if (regex_overview_root.test(window.location.pathname) || regex_overview_url.test(window.location.pathname) ) {
      this.currentPage = 'overview';
    }
  }


  render(){
    return(
      <Wrapper>
        <NavbarContainer>
          <Logo src='./assets/ungc-logo-01.png' alt="Smiley face" onClick={() => window.open('https://www.unglobalcompact.org/', '_blank')}></Logo>
          <Title>2018 United Nations Global Compact Progress Report</Title>
        </NavbarContainer>
        <SubNavContainer>
          <Nav currentPage={this.currentPage}>
            <Link to='/overview' onClick={() => this.setState({currentPage: 'overview'})}>Overview</Link>
            <Link to='/tenprinciples' onClick={() => this.setState({currentPage: 'tenprinciples'})}>Ten Principles</Link>
            <Link to='/sdgs' onClick={() => this.setState({currentPage: 'sdgs'})}>SDGs</Link>
            <Link to='/impact' onClick={() => this.setState({currentPage: 'impact'})}>Impact</Link>
          </Nav>
        </SubNavContainer>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/Navbar.js